import React from "react";
import "./ImageDouble.module.scss";

type Props = {
  item: any;
};

export default function ImageDouble({ item }: Props) {
  // console.log(item, 'item');
  return (
    <div styleName="ImageDouble">
      <div styleName="image">
        {item.attributes.link1 ? (
          <a href={item.attributes.link1}>
            <img alt="content" src={`/storage/${item.attributes.image1}`} />
          </a>
        ) : (
          <img alt="content" src={`/storage/${item.attributes.image1}`} />
        )}
      </div>
      <div styleName="image">
        {item.attributes.link2 ? (
          <a href={item.attributes.link2}>
            <img alt="content" src={`/storage/${item.attributes.image2}`} />
          </a>
        ) : (
          <img alt="content" src={`/storage/${item.attributes.image2}`} />
        )}
      </div>
    </div>
  );
}
